/**
 * Zeus storefront behaviors aligned with index.html (nav, i18n, anchors, counters).
 * Reveal + .reveal is handled in animations.js; FAQ in zeus-faq.js; BA sliders in zeus-ba-slider.js.
 */
(function () {
  function getById(id) {
    return document.getElementById(id);
  }

  // —— Mobile menu ——
  function initMobileMenu() {
    var menu = getById("zeusMobileMenu");
    var toggle = getById("zeusMenuToggle");
    if (!toggle || !menu) return;
    toggle.addEventListener("click", function () {
      menu.classList.toggle("active");
      toggle.classList.toggle("active");
      document.body.style.overflow = menu.classList.contains("active") ? "hidden" : "";
    });
    menu.querySelectorAll("a").forEach(function (link) {
      link.addEventListener("click", function () {
        menu.classList.remove("active");
        toggle.classList.remove("active");
        document.body.style.overflow = "";
      });
    });
  }

  // —— Navbar hide on scroll ——
  function initNavbarScroll() {
    var navbar = getById("navbar");
    if (!navbar) return;
    var lastScroll = 0;
    window.addEventListener(
      "scroll",
      function () {
        var currentScroll = window.pageYOffset;
        if (currentScroll > lastScroll && currentScroll > 100) {
          navbar.classList.add("navbar--hidden");
        } else {
          navbar.classList.remove("navbar--hidden");
        }
        lastScroll = currentScroll;
      },
      { passive: true }
    );
  }

  // —— Smooth in-page anchors (#id) ——
  function initSmoothAnchors() {
    document.addEventListener("click", function (e) {
      var a = e.target.closest && e.target.closest('a[href^="#"]');
      if (!a) return;
      var href = a.getAttribute("href");
      if (!href || href === "#") return;
      var id = href.slice(1);
      if (!id) return;
      var target = document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  }

  // —— Counter animation (hero .stat-num + testimonial .num) when testimonial is visible ——
  function animateCounters() {
    var counters = document.querySelectorAll(".stat-num, .testimonial-count .num");
    counters.forEach(function (counter) {
      var raw = counter.textContent.replace(/[^\d]/g, "");
      var target = parseInt(raw, 10);
      if (isNaN(target) || target <= 0) return;
      var current = 0;
      var increment = Math.ceil(target / 60);
      var timer = setInterval(function () {
        current += increment;
        if (current >= target) {
          counter.textContent = target + "+";
          clearInterval(timer);
        } else {
          counter.textContent = current + "+";
        }
      }, 20);
    });
  }

  function initCounterWhenTestimonialVisible() {
    var testimonialSection = document.querySelector(".testimonial");
    if (!testimonialSection) return;
    var counterObserver = new IntersectionObserver(
      function (entries) {
        if (entries[0] && entries[0].isIntersecting) {
          animateCounters();
          counterObserver.unobserve(testimonialSection);
        }
      },
      { threshold: 0.3 }
    );
    counterObserver.observe(testimonialSection);
  }

  /** Home deep link: /?scroll_to=products → smooth scroll to #products (used by header “Shop Now” off-index). */
  function initHomeProductsDeepLink() {
    var params = new URLSearchParams(window.location.search);
    var want =
      params.get("scroll_to") === "products" ||
      params.get("to") === "products";
    if (!want) return;
    var products = document.getElementById("products");
    if (!products) return;
    requestAnimationFrame(function () {
      products.scrollIntoView({ behavior: "smooth", block: "start" });
      params.delete("scroll_to");
      params.delete("to");
      var q = params.toString();
      var path = window.location.pathname + (q ? "?" + q : "") + window.location.hash;
      window.history.replaceState({}, "", path);
    });
  }

  function boot() {
    initMobileMenu();
    initNavbarScroll();
    initSmoothAnchors();
    initHomeProductsDeepLink();
    initCounterWhenTestimonialVisible();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
